// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"462":"eca8c03e","472":"eca8c03e","627":"e654acdc"}[chunkId] + ".chunk.css";
};